export enum EstadosGestion {
  Asignados = 'Asignados',
  NoAsignados = 'No asignados',
  Baja = 'Baja',
}
